import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import MenuSelection from './components/MenuSelection';
import QuantityMenuSelection from './components/QuantityMenuSelection';
import KitchenDisplay from './components/KitchenDisplay';
import QuantityProducts from './components/QuantityProducts';
import ErrorBoundary from './components/ErrorBoundary';
import { isSessionValid, saveLastRoute } from './auth';
import './App.css';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  const sessionOk = isAuthenticated || isSessionValid();
  return sessionOk ? children : <Navigate to="/" replace />;
};

function LastRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    saveLastRoute(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => isSessionValid());

  return (
    <Router>
      {/* Inside the router so the URL survives a crash and the reload lands on the same screen. */}
      <ErrorBoundary>
        <LastRouteTracker />
        <Routes>
          <Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/menu-selection"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <MenuSelection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quantity-menu-selection"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <QuantityMenuSelection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kitchen-display/:menuName"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <KitchenDisplay />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quantity-products/:menuName"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <QuantityProducts />
              </ProtectedRoute>
            }
          />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
}

export default App;